export default {
  rankOrder: {
    ariaAddOption: 'Добавить {label} в список рейтинга',
    ariaMoveUp: 'Переместить {label} вверх',
    ariaMoveDown: 'Переместить {label} вниз',
    ariaRemoveOption: 'Удалить {label} из списка рейтинга',
  },
  coe: {
    ariaDisclaimer: 'Уведомление',
    ariaQuestion: 'Вопрос',
    ariaConversationHistory: 'История разговора',
    ariaYourResponse: 'Ваш ответ {number}',
    ariaFollowUpQuestion: 'Последующий вопрос {number}',
    ariaResponseInput: 'Поле для ответа',
    ariaRespondingTo: 'Ответ на',
    ariaSendResponse: 'Отправить ответ',
    ariaThinking: 'Думает'
  },
  deviceView: {
    toolbar: 'Устройство предварительного просмотра',
    mobile: 'Мобильный',
    tablet: 'Планшет',
    desktop: 'Компьютер'
  },
  header: {
    customLogoAlt: 'Логотип',
    defaultLogoAlt: 'Логотип QuestDIY'
  }
}
